import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';

import Error from '@material-ui/icons/Error';
import Button from '@material-ui/core/Button';

import { BlueRightArrowIcon, Bulb } from '../../../../images/icons/WrapSvg';

class User extends React.Component {
    handleClick = (event) => {
        if(this.props.superadmin) {
            this.props.history.push('/manage/displays/' + this.props.display.id);
        }
    };

    render() {
        const { display, last, superadmin } = this.props;
        const nombre = `${display.txtlocal}`;
        const color = display.estado === 0 
                        ? 'c_pea' 
                        : display.estado === 1 
                            ? 'c_lipstick' 
                                : display.estado === 2 
                                    ? 'c_golden_yellow' 
                                        : display.estado === 3 
                                            ? 'c_bluish' 
                                            : 'c_cool_grey';   
        console.log(display);
        return (
            <div
                className={
                    'flex_full_row padding_top_24 padding_left_12 margin_left_24 c_grey_blue hand '
                }
            >
                {display.throttle
                    ?   <Error 
                            style={{ fontSize: 24 }}
                            className={'margin_right_12 c_lipstick'}/>
                    :   <Bulb
                            style={{ fontSize: 24 }}
                            className={'margin_right_12 ' + color}
                        />
                }
                <div
                    className={classNames(
                        'flex_full_row  align_center padding_bottom_9',
                        last ? 'noshadow' : 'shadow_down',
                    )}
                >
                    <div className={'flex_full_row '}>
                        <span className="barlow_medium c_dark_grey_blue" onClick={this.handleClick}>{nombre}</span>
                    </div>
                    {display.throttle &&
                        <React.Fragment>
                            
                            <Button 
                                variant="contained"
                                color="secondary" 
                                size="small"
                                onClick={(event) => {
                                    this.props.onThrottle(display.id, display.throttle, display.estado);
                                }}
                                >Reset</Button>
                        </React.Fragment>
                    }
                    {(!display.throttle && display.flags !== 3)  && 
                        <React.Fragment>
                            
                            <Button 
                                variant="contained"
                                color="primary" 
                                size="small"
                                onClick={(event) => {
                                    this.props.onThrottle(display.id, display.throttle, display.flags);
                                }}
                                >Refresh</Button>
                        </React.Fragment>
                    }
                    {superadmin &&
                        <BlueRightArrowIcon color="primary" />
                    }
                </div>
            </div>
        );
    }
}

User.propTypes = {
    history: PropTypes.object.isRequired,
};

User = withRouter(User);

export default User;



// WEBPACK FOOTER //
// ./src/components/complex/manage/displays/Display.js